import React, { useEffect, useState } from "react";
import axios from "axios";
import Logo from '../Logo/Dark/Full - Copy/1Asset 17@72x-8.png';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import Header1 from "../Header/Header1";
import Footer2 from "../Footer/Footer2";

const API_URL = process.env.REACT_APP_API_URL;

export default function InvoiceView() {
  const params = new URLSearchParams(window.location.search);
  const theme = useTheme();
  const transaction_id = params.get("transaction_id");
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/invoices/detail/`, { params: { transaction_id } })
      .then(res => setData(res.data))
      .catch(err => console.error(err));
  }, []);

  if (!data) return <p style={{ textAlign: "center", marginTop: 50, color: "#bbb" }}>Loading...</p>;

  const { invoice, transaction, post, user } = data;

  const price = parseFloat(post.price);
  const gst = price * 0.18;
  const priceWithGST = price + gst;
  const paymentCharges = priceWithGST * 0.02; // 2% of price WITH GST
  const totalPaid = priceWithGST + paymentCharges;

  const userPincode = user.pincode || 0;
  const gstText = (userPincode >= 560001 && userPincode <= 591346)
    ? `CGST: ₹${(gst/2).toFixed(2)}, SGST: ₹${(gst/2).toFixed(2)}`
    : `IGST: ₹${gst.toFixed(2)}`;

  const cardStyle = {
    backgroundColor: "#1e1e1e",
    color: "#eee",
    borderRadius: 12,
    boxShadow: "0 4px 20px rgba(0,0,0,0.5)",
    padding: 30,
    marginBottom: 25
  };

  const tableHeaderStyle = {
    backgroundColor: "#2c2c2c",
    color: "#fff",
    fontWeight: 600
  };

  const tableRowStyle = {
    backgroundColor: "#2a2a2a",
    borderBottom: "1px solid #444"
  };

  const sectionTitleStyle = {
    color: "#90caf9",
    marginBottom: 15
  };

  return (
    <div>
        <Header1/>
    <div style={{ maxWidth: 900, margin: "30px auto", fontFamily: "'Roboto', sans-serif" }}>
        

      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 30 }}>
        <img
          src={Logo}
          alt="Logo"
          style={{
            width: isMobile ? '80px' : '180px',
            height: 'auto'
          }}
        />
        <div style={{ textAlign: "right", lineHeight: 1.5 }}>
          <strong style={{ fontSize: 16, color: "#fff" }}>Anthrasync Solutions Private Limited</strong><br/>
          <span style={{ fontSize: 14, color: "#bbb" }}>
            No 26, Laskar Hosur Road, Adugodi, Bangalore South,<br/>
            Bengaluru, Karnataka 560030, India<br/>
            GST No: 29ABBCA0435C1Z8
          </span>
        </div>
      </div>

      <div style={{ backgroundColor: "#1976d2", color: "#fff", padding: 15, borderRadius: 8, marginBottom: 20 }}>
        <h2 style={{ margin: 0 }}>Invoice #{invoice.invoice_number}</h2>
      </div>

      {/* Transaction Info */}
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 25 }}>
        <div>
          <p style={{ margin: 0, fontWeight: 600 }}>Transaction ID:</p>
          <p style={{ margin: 0, color: "#bbb" }}>{transaction.transaction_id}</p>
        </div>
        <div>
          <p style={{ margin: 0, fontWeight: 600 }}>Date:</p>
          <p style={{ margin: 0, color: "#bbb" }}>{new Date(transaction.created_at).toLocaleString()}</p>
        </div>
      </div>

      {/* Billing Info */}
      <div style={cardStyle}>
        <h3 style={sectionTitleStyle}>Billing Info</h3>
        <p style={{ margin: 2 }}><strong>{user.name} {user.surname}</strong></p>
        <p style={{ margin: 2 }}>{user.address}, {user.city}, {user.state}, {user.country} - {user.pincode}</p>
        <p style={{ margin: 2 }}>Email: {user.email}</p>
        <p style={{ margin: 2 }}>Contact: {user.contact}</p>
      </div>

      {/* Post Details */}
      <div style={{ overflowX: "auto", ...cardStyle }}>
        <h3 style={sectionTitleStyle}>Post Details</h3>
        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 0 }}>
          <thead>
            <tr style={tableHeaderStyle}>
              <th style={{ padding: 12, textAlign: "left" }}>Title</th>
              <th style={{ padding: 12, textAlign: "left" }}>Description</th>
              <th style={{ padding: 12, textAlign: "right" }}>Price</th>
              <th style={{ padding: 12, textAlign: "right" }}>GST</th>
              <th style={{ padding: 12, textAlign: "right" }}>Payment Charges</th>
              <th style={{ padding: 12, textAlign: "right" }}>Total Paid</th>
            </tr>
          </thead>
          <tbody>
            <tr style={tableRowStyle}>
              <td style={{ padding: 12 }}>{post.title}</td>
              <td style={{ padding: 12 }}>{post.description}</td>
              <td style={{ padding: 12, textAlign: "right" }}>₹{price.toFixed(2)}</td>
              <td style={{ padding: 12, textAlign: "right" }}>₹{gst.toFixed(2)}</td>
              <td style={{ padding: 12, textAlign: "right" }}>₹{paymentCharges.toFixed(2)}</td>
              <td style={{ padding: 12, textAlign: "right", fontWeight: 600 }}>₹{totalPaid.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p style={{ fontWeight: 600, marginBottom: 15 }}>GST Details: <span style={{ color: "#bbb" }}>{gstText}</span></p>

      {/* Transaction Summary */}
      <div style={cardStyle}>
        <h3 style={sectionTitleStyle}>Transaction Summary</h3>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
          <span>Amount Paid:</span>
          <span style={{ fontWeight: 600 }}>₹{totalPaid.toFixed(2)}</span>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
          <span>Status:</span>
          <span style={{ fontWeight: 600 }}>{transaction.status}</span>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>Payment Reason:</span>
          <span style={{ fontWeight: 600 }}>{transaction.payment_reason}</span>
        </div>
      </div>

      <a
        href={`${API_URL}/invoices/download/?transaction_id=${transaction.transaction_id}`}
        style={{
          display: "inline-block",
          padding: "12px 25px",
          backgroundColor: "#1976d2",
          color: "#fff",
          textDecoration: "none",
          borderRadius: 6,
          fontWeight: 600,
          transition: "background-color 0.3s",
        }}
        onMouseOver={e => e.currentTarget.style.backgroundColor = "#115293"}
        onMouseOut={e => e.currentTarget.style.backgroundColor = "#1976d2"}
      >
        Download PDF
      </a>
      

    </div>
    <Footer2/>
    </div>
  );
}
